export default {
  classPanel: {
    leaveClass: 'Sortir du cours',
    title: 'Cours',
    handTest: {
      intro: "Pour mieux vous accompagner, j'aimerais connaître la taille de vos mains. Ce sera fait en moins de 5 minutes !",
      skip: 'Ignorer',
      take: 'Je passe le test',
    }
  },
  singClassPanel: {
    structureReminder: 'Rappel Structure',
    lyrics: 'Paroles',
    sing: 'Chanter',
  },
  pianoClassPanel: {
    sectionsCount: 'Cette partie contient {count} sections.',
    singleSection: "Cette partie ne contient qu'une seule section !",
    play: 'Jouer',
  },
  sectionButton: {
    learn: 'Apprendre',
    toWorkOn: 'À travailler !',
  },
  classStepsBar: {
    buttons: {
      steps: 'Étapes',
    }
  },
  demo: {
    title: 'Démonstration',
    description: 'Regardez (sans jouer) ce que nous allons travailler ensuite.',
    name: 'Démonstration',
    shortName: 'Démonstration',
  },
  resumeDemo: {
    title: 'Démonstration',
    description: 'Voici ce que vous avez commencé et que nous allons continuer de travailler.',
  },
  consolidation: {
    title: 'Démonstration',
    description: 'Regardez (sans jouer) l\'ensemble des parties que vous allez enchainer dans l\'ordre suivant : {partListText}',
  },
  classType: {
    pianoBoth: 'Mains Ensemble',
    pianoLeft: 'Main Gauche',
    pianoRight: 'Main Droite',
    consolidation: 'Enchainement',
    sing: 'Chant',
  },
  classTypeTitle: {
    pianoBoth: 'Mains Ensemble',
    pianoLeft: 'Main Gauche',
    pianoRight: 'Main Droite',
    consolidation: 'Enchainement',
    sing: 'Chant',
  },
  playClass: {
    tips: {
      0: 'Pensez à vous tenir bien droit, en gardant les épaules basses, détendues.',
      1: 'Soyez attentif à la position de vos mains, elles doivent rester juste au-dessus du niveau du clavier.',
      2: 'Faites attention à garder les poignets détendus, surtout lorsque la difficulté augmente.',
      3: 'Il faut avoir la sensation de jouer avec le métronome et non de le viser.',
      4: 'Quand vous jouez les mains ensemble vous devez les sentir jouant ensemble sur le même tempo',
      5: 'Faites attention à ce que votre assise soit bien réglée en hauteur. Il faut que vous vous teniez droit et que vous relâchiez les épaules ; les coudes doivent être à la hauteur ou un peu au-dessus de la hauteur des touches du clavier.',
      6: 'Parfois, il vaut mieux s’arrêter quelques minutes. Après une petite pause (ou une bonne nuit de sommeil), les difficultés ont tendance à disparaitre !',
    },
    confirmationsTips: {
      0: 'Pensez à bien utiliser les bons doigtés !',
      1: 'Écoutez vous attentivement pour être sûr de jouer les bonnes notes !',
    },
  },
  stepTransitionPanel: {
    buttons: {
      skip: 'Passer',
      restart: 'Recommencer',
      continue: 'Continuer',
    }
  },
  classStepsPanel: {
    buttons: {
      hide: 'masquer',
      courseMenu: 'Menu du cours',
      playNow: 'Jouer',
      backToSteps: 'Étapes',
      continue: 'Continuer',
    },
    welcome: {
      currentStep: 'En cours',
      alreadyDone: 'Déjà validé',
      demo: 'Démonstration',
      cta: 'Commencer',
    },
  },
  classOverviewPanel: {
    quit: 'Quitter',
  },
  partClassElement: {
    partType: {
      verse: 'Couplet',
      chorus: 'Refrain',
      bridge: 'Pont',
      intro: 'Introduction',
      empty: 'Vide',
      other: 'Autre',
    }
  },

  classTabContent: {
    teacherSuggests: 'LE PROF SUGGÈRE',
    work: 'Travailler',
    workName: 'Travailler {name}',
    inProgress: 'En cours',
    continueNow: 'CONTINUER MAINTENANT',
    startNow: 'COMMENCER MAINTENANT',
    reviewSkills: 'Réviser les compétences',
    allSkillsValidated: 'Toutes les compétences sont validées !',
    courseProgress: 'Progrès du cours',
    review: 'Réviser',
    resume: 'Reprendre',
    replayPart: 'Rejouer {name}',
    resumePart: 'Reprendre {name}',
    playPart: 'Jouer {name}',
    playPartLockedTooltip: 'Valide d\'abord les sections {sections}',
    chain: 'Enchaîner',
    validate: 'Valider',
    fullPiece: 'Morceau complet',
    replayPiece: 'Rejouer le morceau',
    chainFullPiece: 'Enchaîner le morceau complet',
    appearsIn: 'Apparaît dans {name}',
    sectionsLabel: 'Sections : {list}',
    validateHint: 'Validez {name}',
    and: 'et',
    chainParts: 'Enchaîner {p1} + {p2}',
  },
}